import React, { useState } from 'react';

const DismissibleWorkflowAlert = ({ variant = 'info', className = '', children }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className={`alert alert-${variant} workflow-dismissible-alert ${className}`.trim()}
      role="note"
    >
      <div className="workflow-alert-content">{children}</div>
      <button
        type="button"
        className="workflow-alert-close"
        onClick={() => setVisible(false)}
        title="Dismiss"
        aria-label="Dismiss"
      >
        <i className="bi bi-x" aria-hidden="true" />
      </button>
    </div>
  );
};

export default DismissibleWorkflowAlert;
